import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import Fleuron from '../components/Fleuron';
import PostDateTime from '../components/PostDateTime';

const PostTemplate = ({ data }) => {
  const post = data.prismicArticle.data;
  return (
    <div>
      <Helmet>
        <title>{`${post.title.text} – ${data.site.siteMetadata.title}`}</title>
      </Helmet>
      <h1 style={{ marginBottom: 0 }}>{post.title.text}</h1>
      <PostDateTime datetime={post.datetime} />
      <div dangerouslySetInnerHTML={{ __html: post.body.html }} />
      <Fleuron />
    </div>
  );
};

PostTemplate.propTypes = {
  data: PropTypes.object.isRequired,
};

export default PostTemplate;

export const query = graphql`
  query PostQuery($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    prismicArticle(fields: { slug: { eq: $slug } }) {
      data {
        title {
          text
        }
        datetime(formatString: "D. M. YYYY, HH:mm")
        body {
          html
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/post.js